import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../../components/public/Navbar';
import Footer from '../../components/public/Footer';
import { LegalH2 as H2, LegalP as P } from './_legalHelpers';

const VERSION = 'BMJ-TERMS-V1.0-2026-05';

export default function TermsOfService() {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  const effectiveDate = new Date().toLocaleDateString('en-IN', {
    day: 'numeric', month: 'long', year: 'numeric',
  });

  return (
    <div data-testid="terms-of-service-page" className="bg-white min-h-screen">
      <Navbar />
      <main className="pt-28 pb-20">
        <div className="max-w-3xl mx-auto px-5 sm:px-8">
          <Link to="/" data-testid="terms-breadcrumb"
            className="inline-flex items-center text-[11px] font-semibold uppercase tracking-[0.2em] text-[#673c96]/70 hover:text-[#f37721] transition-colors mb-8"
            style={{ fontFamily: 'Montserrat, sans-serif' }}>
            ← Back to Home
          </Link>

          <h1 className="text-3xl sm:text-4xl font-bold tracking-tight text-[#311b52] mb-3"
            style={{ fontFamily: 'Poppins, sans-serif' }}>
            Terms of Service
          </h1>

          <div className="flex flex-col gap-1 mb-10 pb-10 border-b border-[#673c96]/10">
            <p className="text-[13px] text-[#673c96]/80" style={{ fontFamily: 'Montserrat, sans-serif' }} data-testid="terms-effective-date">
              <span className="font-semibold">Effective Date:</span> {effectiveDate}
            </p>
            <p className="text-[13px] text-[#673c96]/80" style={{ fontFamily: 'Montserrat, sans-serif' }}>
              <span className="font-semibold">Version:</span> {VERSION}
            </p>
            <p className="text-[13px] text-[#673c96]/80" style={{ fontFamily: 'Montserrat, sans-serif' }}>
              <span className="font-semibold">Entity:</span> BookMyJab Pvt. Ltd., a private limited company registered in Haryana, India
            </p>
          </div>

          <P>
            These Terms govern your use of BookMyJab&rsquo;s at-home vaccination service. By booking a vaccination through BookMyJab, you accept these Terms together with the <Link to="/privacy-policy" className="text-[#f37721] hover:underline font-medium">Privacy Notice</Link>, <Link to="/refund-policy" className="text-[#f37721] hover:underline font-medium">Refund Policy</Link>, and <Link to="/medical-vaccination-consent" className="text-[#f37721] hover:underline font-medium">Medical Declaration and Vaccination Consent</Link>.
          </P>

          <H2>1. Authorisation to Facilitate</H2>
          <P>
            I authorise BookMyJab to facilitate procurement and administration of the selected vaccine on my behalf or on behalf of the person for whom I am booking the vaccination.
          </P>
          <P>
            I understand that BookMyJab may coordinate with authorised medical practitioners, qualified nurses, licensed pharmacies, authorised distributors, hospitals, clinics, logistics partners and service providers for the purpose of fulfilling this booking.
          </P>

          <H2>2. Medical Suitability and Operational Conditions</H2>
          <P>
            I understand that vaccination shall be administered only subject to doctor review, prescription, medical protocol, medical suitability, vaccine availability, cold-chain integrity and applicable law.
          </P>
          <P>
            I understand that BookMyJab may cancel, defer or reschedule the booking if the doctor, nurse or authorised partner identifies any medical, prescription, vaccine availability, cold-chain, safety, legal or operational concern.
          </P>

          <H2>3. Procurement Through Licensed Channels</H2>
          <P>
            BookMyJab shall not itself sell, stock, distribute or dispense vaccines unless it holds or operates through the required licences, registrations or authorised partners under applicable law. Vaccines shall be procured only through licensed pharmacies, authorised distributors, hospitals, clinics or other legally permitted channels.
          </P>

          <H2>4. Inherent Risks of Vaccination</H2>
          <P>
            I understand that adverse events following immunisation may occur despite proper procurement, storage, handling, screening and administration.
          </P>

          <H2>5. Not an Emergency Service</H2>
          <P>
            I understand that BookMyJab is not an emergency hospital, ambulance service or intensive care provider.
          </P>
          <P>
            In case of severe symptoms, breathing difficulty, swelling of face or throat, fainting, seizure, chest pain, persistent high fever or any serious reaction, I agree to immediately contact emergency medical services, the nearest hospital, ambulance service or local emergency number.
          </P>
          <P>
            BookMyJab may assist in escalation, but emergency care remains the responsibility of the customer, family, guardian and treating hospital.
          </P>

          <H2>6. Limitation of Liability</H2>
          <P>
            To the maximum extent permitted by law, BookMyJab, its doctors, nurses, employees and partners shall not be liable for inherent, known, idiosyncratic, allergic, biological or unforeseeable vaccine reactions where reasonable care, applicable law and medical protocol have been followed.
          </P>
          <P>
            Nothing in these terms excludes or limits liability for proven negligence, gross negligence, wilful misconduct, fraud, breach of statutory duty, wrong vaccine administration, expired vaccine administration, unauthorised administration, or any liability that cannot be excluded under Indian law.
          </P>

          <H2>7. Governing Law and Jurisdiction</H2>
          <P>
            These Terms are governed by the laws of India. Courts at Gurugram (Gurgaon), Haryana shall have exclusive jurisdiction over any dispute, subject to applicable consumer-protection law.
          </P>

          <H2>8. Contact</H2>
          <P>
            <a href="mailto:bookmyjab@gmail.com" className="text-[#f37721] hover:underline font-medium" data-testid="terms-support-email">bookmyjab@gmail.com</a> · <a href="tel:+919873554343" className="text-[#f37721] hover:underline font-medium">+91 9873 55 4343</a>
          </P>
          <P>For grievance, data rights or complaint, see <Link to="/grievance" className="text-[#f37721] hover:underline font-medium">Grievance & Data Rights</Link>.</P>
        </div>
      </main>
      <Footer />
    </div>
  );
}
